module.exports = __webpack_public_path__ + "img/pharma_logo.8cd02eb1.jpg";